import { ModuleWithProviders, NgModule } from '@angular/core'
import { CommonModule, NgOptimizedImage } from '@angular/common'
import { RouterModule } from '@angular/router'

/* Modules */
import { AppCommonModule } from '@common/app-common.module'

/* Components */
import * as navigationComponents from './components'

/* Containers */
import * as navigationContainers from './containers'

/* Layouts */
import * as appCommonLayouts from './layouts'

/* Services */
import * as navigationServices from './services'
import { MessagesService } from '@modules/messages/services'
import { NgSelectModule } from '@ng-select/ng-select'

@NgModule({
	imports: [CommonModule, RouterModule, AppCommonModule, NgOptimizedImage, NgSelectModule],
	declarations: [
		...navigationContainers.containers,
		...navigationComponents.components,
		...appCommonLayouts.layouts
	],
	exports: [
		...navigationContainers.containers,
		...navigationComponents.components,
		...appCommonLayouts.layouts
	],
	providers: [{ provide: 'window', useValue: window }]
})
export class NavigationModule {
	static forRoot(): ModuleWithProviders<NavigationModule> {
		return {
			ngModule: NavigationModule,
			providers: [
				...navigationServices.services,
				MessagesService
			]
		}
	}
}
